<template>
    <div :class="['kimsa-elevation py-3 mx-auto', {'full-width': fullWidth}]">
        <div v-for="(item,i) in items" :key="i" :class="['item-container', {'item-separator': withSeparator(i)}]">
            <div class="item-value">
                {{ item.value }}
            </div>
            <div class="item-name">
                {{ item.name }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TableBasicInfo",
    props: {
        items: {
            type: Array,
            default: () => []
        },
        fullWidth: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        withSeparator(index) {
            const vm = this
            return vm.items.length > index + 1
        }
    }
}
</script>

<style scoped>

.item-container {
    display: inline-block;
    height: 80px;
    width: 110px;
    padding: 12px;
}

.item-separator {
    border-right: 1px solid #99CC00;
}

.item-value {
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    color: #078571;
}

.item-name {
    font-size: 13px;
    line-height: 15px;
    color: #707070;
}

.full-width {
    width: 100%;
    text-align: center;
}

</style>